import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Input, Tooltip } from 'antd';
import { attributeNumber as AttributeNumber } from 'theme/icon';
import styles from './styles.scss';

const NumberAttribute = props => {
  const { isEditable } = props;
  const [value, setValue] = useState(props.value);
  useEffect(() => {
    setValue(props.value);
  }, [props.value]);
  const getFormattedValue = val => {
    const number = +parseFloat(val.toString().replace(',', '.')).toFixed(2);
    return number.toString().replace('.', ',');
  };
  const handleChangeValue = e => {
    const { value: newValue } = e.target;
    const reg = /^(\d*(\s{1})?\d+?)+([/.,]{1})?(\d+)?$/;
    if ((reg.test(newValue) && newValue.length <= 15) || !newValue) {
      setValue(newValue.replace('.', ','));
      props.onChange(newValue.replace(',', '.').replace(/\s+/g, ''));
    }
  };
  return (
    <div className={styles.row}>
      <div className={styles.header}>
        <div className={styles.icon}>
          <AttributeNumber alt="" />
        </div>
        <div className={styles.caption}>
          <Tooltip placement="bottomLeft" title={props.name.length > 25 ? props.name : null}>
            <h4>{_.truncate(props.name, { omission: '...', length: 25 })}</h4>
          </Tooltip>
        </div>
      </div>
      <div className={styles.body}>
        {isEditable ? (
          <Input style={{ width: '100%' }} value={props.value} onChange={handleChangeValue} />
        ) : (
          <React.Fragment>{(value || value === 0) && <span>{getFormattedValue(value)}</span>}</React.Fragment>
        )}
      </div>
    </div>
  );
};

NumberAttribute.propTypes = {
  onChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  isEditable: PropTypes.oneOf([PropTypes.objectOf(PropTypes.bool), PropTypes.bool]).isRequired,
};

NumberAttribute.defaultProps = {
  value: null,
};

export default NumberAttribute;
